import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CycleValidationPostingFile } from './CycleValidationPostingFile';
import { CycleValidationReportFile } from './CycleValidationReportFile';
import { CycleValidationApproval } from './CycleValidationApproval';
import { FileResource } from './FileResource';

export class SweepFileResource extends FBaseService implements FileResource {
  public async getFiles(fiId: string, cycleId: number): Promise<CycleValidationPostingFile[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/sweep-files/${cycleId}`);

    const result: CycleValidationPostingFile[] = response.data.data;
    return result;
  }

  public async getReportFiles(fiId: string, cycleId: number): Promise<CycleValidationReportFile[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/cycle-validation-sweep-report-files/${cycleId}`);

    const result: CycleValidationReportFile[] = response.data.data;
    return result;
  }

  public async getZeroByteApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/cycle-validation-approval/SWEEP_ZEROBYTE/${snapshotId}`);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }

  public async saveZeroByteApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const approval: CycleValidationApproval = {
      id: null,
      approvalDateTime: null,
      snapshotId,
      approvalUserId: null,
      approvalState: 'APPROVED',
      approvalType: 'SWEEP_ZEROBYTE',
      subFolders: [],
    };
    const response: AxiosResponse = await this.apiClient.put(`/api/rcx/director/${fiId}/cycle-validation-approval`, approval);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }


  public async filesExpected(fiId: string): Promise<boolean> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/does-produce-sweep-file`);
    return response.data.data;
  }
}

export default SweepFileResource;
